module.exports = __webpack_public_path__ + "img/report-5.cd8f96cf.jpg";